export const OPEN_ONBOARDING_WIZARD = "OPEN_ONBOARDING_WIZARD";
export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const RESET_STATE = "RESET_STATE";

export type DrawerActions = "OPEN_ONBOARDING_WIZARD" | "CLOSE_DRAWER" | "RESET_STATE";
